import { FC } from 'react';
import styles from './Home.module.css';
import {
  MDBRow,
  MDBCol
} from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

interface HomeProps { }

const Home: FC<HomeProps> = () => {

  const { t } = useTranslation();
  return (
    <div className={styles.Home}>
      <div className='pb-4 border rounded-5 p-4 w-100 contrasting-bg' style={{ minHeight: 'calc(100vh - 389.56px)' }}>
        <h2 className='text-center mb-4' style={{ color: '#086972' }}><strong>{t('NEWS')}</strong></h2>
        <div className='d-flex justify-content-center align-items-center'>

          <MDBRow className='row-cols-1 row-cols-md-2'>
            <MDBCol>
              <div className="card mb-6">
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      src="arbeidstilsynet.svg"
                      alt="Godkjent bemanningsforetak"
                      className="img-fluid rounded-start"
                      style={{ width: '80%', height: '80%', marginTop: '5%' }}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h5 className="card-title">{t('Approved staffing agency')}</h5>
                      <p className="card-text">
                        {t('Approved_staffing_agency_text')}
                      </p>
                      <a href="https://www.arbeidstilsynet.no/bemanningsvirksomhet/935422809" target="_blank" rel="noopener noreferrer">{t('Link to the labor inspectorate')}</a>
                      <p className="card-text">
                        <small className="text-muted">Oxana Eide - 23.05.2025</small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </MDBCol>
            <MDBCol>
              <div className="card mb-6">
                <div className="row g-0">
                  <div className="col-md-4">
                    <img
                      src="brreg.jpg"
                      alt="Registring i Brønnøysundsregistrene"
                      className="img-fluid rounded-start"
                      style={{ width: '80%', height: '80%', marginTop: '5%' }}
                    />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h5 className="card-title">{t('Registration in the Brønnøysund Registers')}</h5>
                      <p>
                        {t('Registration_in_the_Brønnøysund_Registers_text')}
                      </p>
                      <a href="https://virksomhet.brreg.no/nb/oppslag/enheter/935422809" target="_blank" rel="noopener noreferrer">{t('Link to the Brønnøysund Registers')}</a>
                      <p className="card-text">
                        <small className="text-muted">Oxana Eide - 28.03.2025</small>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </MDBCol>
          </MDBRow>
        </div>
      </div>
    </div>
  );
}

export default Home;
